import type { DeviceManifest } from '@rapoo/device-sdk'
import {
  baseChannel0To7,
  baseChildDeviceEnabled,
  createBaseScreenImageCapability,
} from './generate/capabilityPresets'
import { p8BaseLightBandEffects } from './generate/lightingPresets'

/**
 * ESPR8PRO 底座设备清单
 */
const rapooESPR8PRO: DeviceManifest = {
  channel: ['china_cybercafe'],
  model: 'ESPR8PRO',
  mainControl: 'ESPR8PRO',
  type: 'base',
  version: '1.0.0',
  hardware: {
    vendorId: 0x24ae,
    productId: 0x1441,
    currentPid: 0x1441,
    transport: 'HID',
    filters: [
      {
        usagePage: 65280,
        usage: 14,
        description: 'Base WebHID Command Interface',
        type: 'default',
      },
      {
        usagePage: 65280,
        usage: 2,
        description: 'Base Nordic Firmware Update Interface',
        type: 'update',
      },
      {
        usagePage: 65280,
        usage: 1,
        description: 'Base WCH Firmware Update Interface',
        type: 'updateWCH',
      },
    ],
  },
  driver: 'VT_nrf54L_Base',
  baseDisplay: 'screen',
  ui: {
    assetsDir: 'manifests/ESPR8PRO',
    colors: {
      series: [
        {
          name: 'common.products.ESPR8PRO.Iridescent_Green',
          value: ['#296B47', '#3D233F'],
          key: 'Iridescent_Green',
        },
        {
          name: 'common.products.ESPR8PRO.Phantom_Green',
          value: '#376F37',
          key: 'Phantom_Green',
        },
      ],
      current: 'Iridescent_Green',
    },
    icon: 'Hardware-Wireframe-Base',
    overview: true,
  },
  capabilities: [
    {
      type: 'lighting',
      config: {
        enable: true,
        effects: p8BaseLightBandEffects,
      },
    },
    createBaseScreenImageCapability({
      maxScreenSlots: 8,
      systemPages: [
        {
          slot: 0,
          kind: 'home',
          presetScreens: [
            { style: 0, asset: 'preset1.png' },
            { style: 1, asset: 'preset2.png' },
            { style: 2, asset: 'preset3.png' },
          ],
        },
      ],
    }),
    baseChannel0To7,
    baseChildDeviceEnabled,
  ],
  layout: {
    keys: [],
  },
}

export default rapooESPR8PRO
